import React, { useContext, useState, useCallback } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { UserContext } from 'containers/pages/ManageUsers/usersContext';
import {
  SvgDeactivate,
  SvgReset,
  SvgEmail,
  SvgProfileCircle,
  SvgReactivate,
} from 'components/SvgIcon';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

export const ActionBar = ({
  onAddTeam,
  onDeactivate,
  onResetPassword,
  onReactivate,
  sendBulkEmail,
  'data-testid': dataTestId,
}) => {
  const {
    featureState: { welcomeEmail },
  } = useContext(FeatureContext);
  const {
    userState: { selectedUserList, userFilterStatus },
  } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);

  const wrappedOnReset = useCallback(() => {
    setIsLoading(true);
    onResetPassword().finally(() => setIsLoading(false));
  }, [onResetPassword]);

  const wrappedSendBulkEmail = useCallback(() => {
    setIsLoading(true);
    sendBulkEmail().finally(() => setIsLoading(false));
  }, [sendBulkEmail]);

  const TableActions = () => {
    if (userFilterStatus) {
      return (
        <>
          <button
            type="button"
            className="action-bar__item action-bar__item--btn"
            onClick={onAddTeam}
            data-testid="PlatformAdminUI-UsersLink-ActionBar-AddTeam"
          >
            <SvgProfileCircle />
            <span className="action-bar__text">Add Team</span>
          </button>
          {onDeactivate && (
            <button
              type="button"
              className="action-bar__item action-bar__item--btn"
              onClick={onDeactivate}
              data-testid="PlatformAdminUI-UsersLink-ActionBar-Deactivate"
            >
              <SvgDeactivate />
              <span className="action-bar__text">Deactivate</span>
            </button>
          )}
          {onResetPassword && (
            <button
              type="button"
              className="action-bar__item action-bar__item--btn"
              onClick={wrappedOnReset}
              disabled={isLoading}
              data-testid="PlatformAdminUI-UsersLink-ActionBar-ResetPassword"
            >
              <SvgReset />
              <span className="action-bar__text">Reset Password</span>
            </button>
          )}
          {welcomeEmail && (
            <button
              type="button"
              className="action-bar__item action-bar__item--btn"
              onClick={wrappedSendBulkEmail}
              data-testid="PlatformAdminUI-UsersLink-ActionBar-EmailInvite"
            >
              <SvgEmail />
              <span className="action-bar__text">Email Invite</span>
            </button>
          )}
        </>
      );
    }

    return (
      <button
        type="button"
        className="action-bar__item action-bar__item--btn"
        onClick={onReactivate}
        data-testid="PlatformAdminUI-UsersLink-ActionBar-Reactivate"
      >
        <SvgReactivate />
        <span className="action-bar__text">Reactivate</span>
      </button>
    );
  };

  return (
    <Grid container item alignItems="center">
      <span className="action-bar__item" data-testid={dataTestId}>
        {selectedUserList.length} users selected
      </span>
      <TableActions />
    </Grid>
  );
};
